import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import { toast } from "@/hooks/use-toast"
import { getApiErrorMessage } from "@/lib/api-error"

export type AddRepicRetryRequest = {
  id: string
  day: number
}

export const addRepicRetry = async (
  { id, day }: AddRepicRetryRequest,
  whiteLabelUuid: string
) => {
  const url = `${ENDPOINTS.REPIC_CONFIGURATION}/${id}/add-retry`
  const { data } = await api.post(
    url,
    { day },
    {
      headers: {
        "x-white-label-uuid": whiteLabelUuid,
      },
    }
  )
  return data
}

export const useAddRepicRetry = () => {
  const queryClient = useQueryClient()
  const { selectedWhiteLabel } = useAuth()
  const whiteLabelUuid = selectedWhiteLabel?.uuid

  return useMutation<
    unknown,
    unknown,
    AddRepicRetryRequest
  >({
    mutationFn: async (payload: AddRepicRetryRequest) =>
      addRepicRetry(payload, whiteLabelUuid as string),
    onSuccess: () => {
      toast({
        title: "Dia adicionado com sucesso",
        variant: "success",
      })

      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] ===
          ENDPOINTS.REPIC_CONFIGURATION,
      })
    },
    onError: (error: unknown) => {
      toast({
        title: getApiErrorMessage(
          error,
          "Erro ao adicionar dia"
        ),
        variant: "destructive",
      })
    },
  })
}

export default useAddRepicRetry
